module.exports = __webpack_public_path__ + "static/media/6.10d51da4.JPG";